import React from 'react';
import WorkbookDay1 from './WorkbookDay1';
import WorkbookDay2 from './WorkbookDay2';
import WorkbookDay3 from './WorkbookDay3';
import WorkbookDay4 from './WorkbookDay4';
import WorkbookDay5 from './WorkbookDay5';
import WorkbookDay6 from './WorkbookDay6';
import WorkbookDay7 from './WorkbookDay7';
import WorkbookDay8 from './WorkbookDay8';
import WorkbookDay9 from './WorkbookDay9';
import WorkbookDay10 from './WorkbookDay10';

export default function WorkbookRouter({ user, workbook, onNav }) {
  if (!workbook) return null;
  const props = { user, onNav };
  switch (workbook.day) {
    case 1:  return <WorkbookDay1  {...props} />;
    case 2:  return <WorkbookDay2  {...props} />;
    case 3:  return <WorkbookDay3  {...props} />;
    case 4:  return <WorkbookDay4  {...props} />;
    case 5:  return <WorkbookDay5  {...props} />;
    case 6:  return <WorkbookDay6  {...props} />;
    case 7:  return <WorkbookDay7  {...props} />;
    case 8:  return <WorkbookDay8  {...props} />;
    case 9:  return <WorkbookDay9  {...props} />;
    case 10: return <WorkbookDay10 {...props} />;
    default: return null;
  }
}
